export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_LOGOUT = 'USER_LOGOUT'



// WEBPACK FOOTER //
// ./src/store/actions/user.js